import React, { useEffect, useState } from "react";
import axios from "axios";
import ReactModal from "react-modal";

function CreaEstandarApoyo(props) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };

  const [country, setCountry] = useState([]);
  const [countryid, setCountryid] = useState("");
  const [countryDescription, setCountryDescription] = useState("");
  const [countryName, setCountryName] = useState(""); // Estado para el nombre del estándar
  const [st, setSt] = useState([]);
  const [stateid, setStateid] = useState("");
  const [city, setCity] = useState([]);

  const [postElemento, setPostElemento] = useState("");
  const [postFortaleza, setPostFortaleza] = useState("");
  const [postOportunidad, setPostOportunidad] = useState("");

  useEffect(() => {
    const getcountry = async () => {
      const rescountry = await fetch(
        "https://suadesarrollo.azurewebsites.net/api/ObtenerEstandaresApoyoAsistenciales?TipoEstandar=Apoyo",
      );
      const rescon = await rescountry.json();
      setCountry(rescon);
    };
    getcountry();
  }, []);

  const handleCountryChange = (event) => {
    const selectedCountryId = event.target.value;
    setCountryid(selectedCountryId);

    const selectedCountry = country.find(
      (country) => country.id == parseInt(selectedCountryId),
    );
    if (selectedCountry) {
      setCountryDescription(selectedCountry.descripcion);
      setCountryName(selectedCountry.estandar); // Guardar el nombre del estándar
    } else {
      setCountryDescription("");
      setCountryName(""); // Limpiar el nombre del estándar si no se encuentra
    }
  };

  useEffect(() => {
    if (countryid !== "") {
      const getstate = async () => {
        const resstate = await fetch(
          `https://suadesarrollo.azurewebsites.net/api/ObtenerCriterios?IdEstandar=${countryid}`,
        );
        const resst = await resstate.json();
        setSt(resst);
      };
      getstate();
    }
  }, [countryid]);

  const handleStateChange = (event) => {
    const selectedStateId = event.target.value;
    setStateid(selectedStateId);
  };

  useEffect(() => {
    if (stateid !== "") {
      const getcity = async () => {
        const rescity = await fetch(
          `https://suadesarrollo.azurewebsites.net/api/ObtenerSubCriterios?IdCriterio=${stateid}`,
        );
        const rcity = await rescity.json();
        setCity(rcity);
      };
      getcity();
    }
  }, [stateid]);

  const postData = (e) => {
    e.preventDefault();
    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/CargueMasivosEstandarCualitativo",
      data: {
        estandar: countryName, // Usar el nombre del estándar
        fortalezas: postFortaleza,
        elementosVerificacion: postElemento,
        oportunidadMejora: postOportunidad,
        Tipo: "Apoyo",
        solicitudId: props.solicitudId,
      },
    })
      .then((response) => {
        console.log(response.data);
        window.location.reload();
        window.alert("creada");
      })
      .catch((error) => {
        console.log(error);
        alert("Error al crear: " + error);
      });
  };

  return (
    <div className="test">
      <button
        variant="contained"
        className="btn btn-primary"
        color="primary"
        onClick={handleOpenModalTest}
      >
        Crear Estandar
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Institucion"
      >
        <div className="container">
          <div className="text-center">
            <div className="container-fluid">
              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <h6 className="m-0 font-weight-bold text-primary">
                    Estandares Apoyo
                  </h6>
                  <hr />
                  <select
                    className="btn btn-secondary btn-user btn-block text-left"
                    onChange={handleCountryChange}
                  >
                    <option value="">Seleccione Estandar</option>
                    {country.map((getcon, index) => (
                      <option key={index} value={getcon.id}>
                        {getcon.estandar}
                      </option>
                    ))}
                  </select>
                  <textarea
                    className="form-control"
                    rows="6"
                    value={countryDescription}
                    readOnly
                  ></textarea>
                  CRITERIOS
                  <textarea
                    className="form-control"
                    rows="6"
                    value={st.map((getst) => getst.criterio).join("\n")}
                    readOnly
                  ></textarea>
                  <br />
                  <hr />
                  <div className="form-group">
                    <div className="col-sm-12">
                      <textarea
                        type="text"
                        className="form-control form-control-user"
                        rows="3"
                        placeholder="Fortalezas"
                        onChange={(e) => setPostFortaleza(e.target.value)}
                      />
                    </div>
                    <hr />
                    <div className="col-sm-12">
                      <textarea
                        type="text"
                        className="form-control form-control-user"
                        rows="3"
                        placeholder="Elementos de verificación"
                        onChange={(e) => setPostElemento(e.target.value)}
                      />
                    </div>
                    <hr />
                    <div className="col-sm-12">
                      <textarea
                        type="text"
                        className="form-control form-control-user"
                        rows="3"
                        placeholder="Oportunidad de mejora"
                        onChange={(e) => setPostOportunidad(e.target.value)}
                      />
                    </div>
                  </div>
                  <center>
                    <button
                      className="btn btn-primary btn-user btn-block"
                      onClick={postData}
                    >
                      Guardar
                    </button>
                  </center>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}

export default CreaEstandarApoyo;
